@import 'styles/variables';
@import 'styles/mixins';
@import 'styles/blaze/mixins';

.header {
  padding: 10px 0;

  @include for-desktop-only {
    padding: 20px;
    display: flex;
    gap: 10px;
  }
}

.content {
  display: flex;
  flex-direction: column;
  gap: 25px;
  padding: 0px 12px;

  @include for-desktop-only {
    padding: 0px 20px;
  }
}

.form {
  display: flex;
  flex-direction: column;
  gap: 25px;
  padding-bottom: 48px;
}

.inputs {
  display: flex;
  gap: 10px;
  flex-direction: column;
}

.footer {
  @include for-desktop-only {
    display: flex;
    padding: 20px 0;
    width: 100%;
  }
}

.buttonContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.buttonContainerRight {
  display: flex;
  align-items: center;
  gap: 12px;
}

.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  width: 100%;
}
